import React from "react";
import { ContextContract } from "./types";
import { appErrorDefault, contextDefault } from "./defaults";

export const Context: React.Context<ContextContract> = React.createContext(contextDefault);

export const ContextProvider = (props: { children: React.ReactNode }): JSX.Element => {
    const [appError, setAppError] = React.useState(appErrorDefault);

    const store: ContextContract = {
        appErrorState: appError,
        setAppErrorState: setAppError,
    }

    return(
        <Context.Provider value={store} >
            {props.children}
        </Context.Provider>
    );
}
